module.exports = __webpack_public_path__ + "img/gb00_.prt.01c8419f.jpg";